// Import CSS
import './index.css'
import Lenis from 'lenis';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { loadPatch } from "@web-kits/audio";

gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;

const lenis = new Lenis({
    autoRaf: true,
    duration: 1,
    anchors: true,
    prevent: (node) => node.classList?.contains('drawer') || node.classList?.contains('oke-modal') || node.classList?.contains('nm-modal-container') || node.classList?.contains('side-panel') || node.classList?.contains('popover')
});

lenis.on('scroll', ScrollTrigger.update);

window.lenis = lenis;

// Import JS
import Alpine from 'alpinejs'

// Globals
window.Alpine = Alpine;

// Start Alpine.js
Alpine.start();

(async () => {
    const retroPatch = await loadPatch(window.themeVariables.assets.retroSoundPatch);

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-sound-trigger]');
        if (!trigger) return;

        const sound = trigger.dataset.soundTrigger;
        console.log(sound);

        try {
            retroPatch.play(sound);
        } catch (error) {
            console.warn(`Sound "${sound}" not found in retro patch`, error);
        }
    });
})();